<template>
  <Panel lineColor="var(--primary-color)">
    <v-row align="center">
      <v-col cols="12" md="6">
        <FormSelect
          :key="aliasSelecionado"
          label="Documento"
          :value="aliasSelecionado"
          :options="opcoesDocumento"
          :disabled="disabled"
          @input="$emit('update:aliasSelecionado', $event)"
        />
      </v-col>
      <v-col cols="12" md="6" class="toolbar-chips">
        <Chip
          color="primario"
          text="Tipo: PDF"
          :small="true"
          :pill="true"
          :outlined="true"
          :dense="true"
          icon="fas fa-file-pdf"
        />
        <Chip
          v-if="personalizado"
          color="green"
          text="Personalizado"
          :small="true"
          :pill="true"
          :outlined="true"
          :dense="true"
          icon="fas fa-palette"
        />
        <Chip
          v-else
          color="cyan"
          text="Padrão LifeApps"
          :small="true"
          :pill="true"
          :outlined="true"
          :dense="true"
          icon="fas fa-layer-group"
        />
      </v-col>
      <v-col cols="12" class="mt-n6">
        <p class="where-used mb-5">
          <v-icon size="14" class="mr-1">fas fa-map-marker-alt</v-icon>
          <strong>Onde é usado:</strong> {{ ondeUsado }}
        </p>
        <p class="nota-informativa">
          <v-icon size="14" color="primario">fas fa-info-circle</v-icon>
          <strong>Templates PDF comerciais:</strong> edite o HTML com
          placeholders Mustache no formato <code v-pre>{{ variavel }}</code
          >. A pré-visualização usa dados de exemplo do catálogo, sem pedido
          real.
        </p>
      </v-col>
    </v-row>
  </Panel>
</template>

<script>
import Panel from "@/components/Panel";
import FormSelect from "@/components/form/FormSelect";
import Chip from "@/components/Chip";

export default {
  name: "TemplateDocumentosToolbar",
  components: { Panel, FormSelect, Chip },
  props: {
    aliasSelecionado: { type: String, default: "" },
    opcoesDocumento: { type: Array, default: () => [] },
    personalizado: { type: Boolean, default: false },
    ondeUsado: { type: String, default: "" },
    disabled: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.toolbar-chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.where-used {
  margin: 0 0 10px;
  font-size: 0.9rem;
  color: #6b7280;
  text-align: left;
  line-height: 1.45;
}

.nota-informativa {
  background: #f5f7fa;
  border-left: 3px solid var(--primary-color);
  border-radius: 8px;
  padding: 10px 12px;
  margin: 0;
  color: #6a6c6f;
  text-align: left;
  font-size: 0.9rem;
  line-height: 1.45;
}

.nota-informativa .v-icon {
  margin-right: 8px;
}

.nota-informativa code {
  background: #fff;
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 0.9em;
}
</style>
